import { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import type { BarConfig } from "shared/atoms/Charts";

export const useBars = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const bars: BarConfig[] = useMemo(
    () => [
      {
        dataKey: "rtm_short_adherence",
        name: t(`dashboard.tables.notes.types.RTM_SHORT_ADHERENCE`),
        color: theme.colors.redesign.p100,
      },
      {
        dataKey: "rtm_adherence",
        name: t(`dashboard.tables.notes.types.RTM_ADHERENCE`),
        color: theme.colors.redesign.p80,
      },
      { dataKey: "rtm_partial", name: t(`dashboard.tables.notes.types.RTM_PARTIAL`), color: theme.colors.redesign.p70 },
      { dataKey: "rtm_first", name: t(`dashboard.tables.notes.types.RTM_FIRST`), color: theme.colors.redesign.p60 },
      {
        dataKey: "rtm_additional",
        name: t(`dashboard.tables.notes.types.RTM_ADDITIONAL`),
        color: theme.colors.redesign.p50,
      },
      { dataKey: "rtm_initial", name: t(`dashboard.tables.notes.types.RTM_INITIAL`), color: theme.colors.redesign.p30 },
    ],
    [t, theme]
  );

  return { bars };
};
